export default {
  translation: {
    common: {
      accept: 'Acceptera',
      alreadyUser: 'Redan användare?',
      and: 'och',
      backToLogin: 'Tillbaka till inloggningssidan',
      continueWith: 'Fortsätt med {{provider}}',
      coreNotFound: 'Kunde inte hämta kärninställningar',
      createAccount: 'Skapa ett konto',
      createYourAccount: 'Skapa ditt konto',
      emailOrUsername: 'E-post eller användarnamn',
      invalidUsernameOrPassword: 'Ogiltigt användarnamn eller lösenord',
      localRegistrationDisabled: 'Lokal användarregistrering är inaktiverad av administratören',
      login: 'Logga in',
      logInToBoards: 'Logga in',
      newToBoards: 'Ny på 4ga Boards?',
      noInternetConnection: 'Ingen internetanslutning',
      pageNotFound_title: 'Sidan hittades inte',
      password: 'Lösenord',
      policyNotAccepted: 'Acceptera vänligen Användarvillkor och Integritetspolicy',
      privacyPolicy: 'Integritetspolicy',
      register: 'Registrera',
      registerWithGoogle: 'Registrera med Google',
      registrationDisabled: 'Användarregistrering är inaktiverad av administratören',
      serverConnectionFailed: 'Anslutning till server misslyckades',
      ssoRegistrationDisabled: 'SSO-registrering är inaktiverad av administratören',
      termsOfService: 'Användarvillkor',
      togglePasswordVisibility: 'Visa/dölj lösenord',
      unknownError: 'Okänt fel, försök igen senare',
    },

    action: {
      logIn: 'Logga in',
    },
  },
};
